<template>
  <div v-if="!item.meta.isNotMenu" class="menu-wrapper">
    <template
      v-if="isOnlyOneMenu(item)"
    >
      <router-link :to="{name: onlyOneChild.name}">
        <el-menu-item
          :index="onlyOneChild.name"
        >
          <i :class="`el-icon-${ onlyOneChild.meta.style || 'news' }`"></i>
          <span slot="title">{{ onlyOneChild.meta.title }}</span>
        </el-menu-item>
      </router-link>
    </template>

    <!-- <template
      v-else-if="(item.children && item.children.length === 1)"
    >
      <router-link :to="{name: item.children[0].name}">
        <el-menu-item
          :index="item.children[0].name"
        >
          <i :class="`el-icon-${ item.children[0].meta.style || 'news' }`"></i>
          <span slot="title">{{ item.children[0].meta.title }}</span>
        </el-menu-item>
      </router-link>
    </template> -->

    <el-submenu
      v-else
      ref="subMenu"
      :index="item.name"
      popper-append-to-body
    >
      <template slot="title">
          <i :class="`el-icon-${ item.meta.style || 'news' }`"></i>
        <span>{{ item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.name"
        :is-nest="true"
        :item="child"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    this.onlyOneChild = null;
    return {};
  },
  created() {
  },
  methods: {
    isOnlyOneMenu(item) {
      if (!item.children || !item.children.length) {
        this.onlyOneChild = item;
        return true;
      }
      // 子菜单只有一个
      if (item.children.length === 1
        // 子菜单有多个，但是只有一个展示，其余都不展示的情况
        || item.children.filter((child) => !child?.meta?.isNotMenu).length === 1) {
        // eslint-disable-next-line prefer-destructuring
        this.onlyOneChild = item.children[0];
        return true;
      }
      return false;
    },
    resolvePath(routePath) {
      // const resourceCode = (route.resourceCode ?? '').toLocaleUpperCase();
      // if (resourceCode === '_BLANK') {
      //   // 新标签跳转
      //   return `${window.location.origin}/#${routePath}`;
      // }
      // if (isExternal(routePath)) {
      //   return routePath;
      // }
      // if (isExternal(this.basePath)) {
      //   return this.basePath;
      // }
      // const resRoutePath = resourceCode.substring(0, 6) === 'OLDBPS'
      //   ? `/iframe?website=${this.getOldBpsWebsite(routePath)}`
      //   : routePath;
      // return path.resolve(this.basePath || '', resRoutePath || '');
      return routePath;
    },
  },
};
</script>
